// extracted by mini-css-extract-plugin
export default {"tags-list":"Toolbar_tags-list__pm6Mk"};